import React, { useState, useEffect } from 'react';
import SEOHead from '../components/SEOHead';
import RelatedServices from '../components/RelatedServices';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    schedule: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    translate: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"/>
      </svg>
    ),
    language: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"/>
      </svg>
    ),
    public: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
      </svg>
    ),
    groups: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zM4 18v-1c0-1.1.9-2 2-2s2 .9 2 2v1h2v-1c0-2.21-1.79-4-4-4s-4 1.79-4 4v1h2zm8-2c0-1.1.9-2 2-2s2 .9 2 2v1h2v-1c0-2.21-1.79-4-4-4s-4 1.79-4 4v1h2v-1z"/>
      </svg>
    ),
    business: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
      </svg>
    ),
    star: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
      </svg>
    ),
    trending_up: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const BilingualAIReceptionist = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  const [currentCallType, setCurrentCallType] = useState(0);
  
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: 'bilingual business'
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const callExamples = [
    {
      type: "Spanish Customer Service",
      time: "Tuesday, 3:45 PM",
      customer: "Hola, necesito hacer una cita para reparar mi aire acondicionado. ¿Pueden venir mañana?",
      response: "¡Por supuesto! Puedo programar su reparación de aire acondicionado para mañana a las 2 PM. Nuestro técnico certificado llegará con todas las herramientas necesarias.",
      translation: "Hello, I need to make an appointment to repair my air conditioning. Can you come tomorrow? // Of course! I can schedule your AC repair for tomorrow at 2 PM. Our certified technician will arrive with all necessary tools.",
      outcome: "$285 AC repair",
      color: "blue"
    },
    {
      type: "English to Spanish Business",
      time: "Friday, 11:20 AM", 
      customer: "I need to schedule a consultation for my restaurant. Do you have any Spanish-speaking consultants?",
      response: "Absolutely! I can schedule your restaurant consultation with our bilingual business consultant for Monday at 10 AM. They'll conduct the meeting in Spanish and provide all materials in both languages.",
      outcome: "$1,500 consultation",
      color: "blue"
    },
    {
      type: "French Medical Appointment",
      time: "Monday, 9:15 AM",
      customer: "Bonjour, je voudrais prendre rendez-vous avec le docteur pour mon fils. C'est urgent.",
      response: "Bonjour! Je comprends que c'est urgent. Je peux programmer un rendez-vous pour votre fils aujourd'hui à 14h avec le Dr. Martinez. Il parle français couramment.",
      translation: "Hello, I would like to make an appointment with the doctor for my son. It's urgent. // Hello! I understand it's urgent. I can schedule an appointment for your son today at 2 PM with Dr. Martinez. He speaks French fluently.",
      outcome: "$150 urgent visit",
      color: "blue"
    }
  ];

  const testimonials = [
    {
      quote: "Our Spanish-speaking customers feel completely welcomed and understood. The AI handles both languages perfectly and our Hispanic customer base has grown 140%.",
      author: "Maria Rodriguez",
      business: "Rodriguez Construction",
      result: "140% Hispanic customer growth"
    },
    {
      quote: "From English to Mandarin, every customer gets native-level service. Our international business has expanded dramatically since implementing bilingual AI.",
      author: "David Chen",
      business: "Global Business Solutions",
      result: "300% international growth"
    },
    {
      quote: "French, Spanish, English - our AI receptionist handles them all seamlessly. We've become the go-to medical practice for our diverse community.",
      author: "Dr. Sarah Johnson",
      business: "Community Health Center",
      result: "Serves 5 languages perfectly"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCallType(prev => (prev + 1) % callExamples.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone) {
      alert('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: 'bilingual business' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };
  
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <MaterialIcon name="close" className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    );
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "Bilingual AI Receptionist - Serve Customers in Multiple Languages",
    "description": "Bilingual AI receptionist speaks Spanish, French, Mandarin, and more. Perfect for diverse communities and international businesses. Native-level fluency in any language.",
    "author": {
      "@type": "Organization",
      "name": "Receptioneer.ai"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Receptioneer.ai",
      "url": "https://receptioneer.ai"
    },
    "datePublished": "2025-01-17",
    "dateModified": "2025-01-17"
  };

  return (
    <>
      <SEOHead
        title="Bilingual AI Receptionist | Serve Customers in Spanish, French & More"
        description="Bilingual AI receptionist speaks Spanish, French, Mandarin, and 50+ languages with native fluency. Perfect for diverse communities and international businesses."
        keywords="bilingual ai receptionist, spanish speaking receptionist ai, multilingual virtual receptionist, french ai receptionist, mandarin phone service, international business receptionist"
        canonical="https://receptioneer.ai/bilingual-ai-receptionist"
        ogTitle="Bilingual AI Receptionist - Native-Level Service in Any Language"
        ogDescription="Serve Spanish, French, Mandarin, and 50+ language customers with perfect fluency. Expand your business to any community with bilingual AI."
        ogImage="https://receptioneer.ai/images/og-image.jpg"
        structuredData={structuredData}
      />
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Try Live Demo
              </a>
              <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Login
              </button>
            </div>
          </div>
        </header>
        
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-indigo-900 via-indigo-800 to-indigo-700 text-white">
          <div className="max-w-6xl mx-auto grid lg:grid-cols-2 min-h-[85vh] items-center">
            <div className="px-6 py-12 lg:py-20">
              <div className="inline-flex items-center bg-indigo-700 text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
                🌍 Multilingual Service
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
                Serve Every Customer
                <br />
                <span className="text-indigo-200">In Their Language</span>
              </h1>
              
              <p className="text-xl text-indigo-100 mb-8 leading-relaxed">
                Your bilingual AI receptionist speaks Spanish, French, Mandarin, and 50+ languages with native fluency. Expand your business to any community.
                <strong className="text-white"> Perfect communication, zero language barriers.</strong>
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-12">
                <button 
                  onClick={() => setShowWaitlistModal(true)}
                  className="bg-white text-indigo-900 hover:bg-indigo-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                >
                  Get Bilingual AI →
                </button>
                
                <a
                  href="tel:+17863845350"
                  className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-indigo-900 px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300"
                >
                  <MaterialIcon name="phone" className="w-5 h-5" />
                  Test Multiple Languages
                </a>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div className="text-center">
                  <div className="text-2xl font-black text-white">50+</div>
                  <div className="text-indigo-200 text-sm">Languages</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">100%</div>
                  <div className="text-indigo-200 text-sm">Native Fluency</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">24/7</div>
                  <div className="text-indigo-200 text-sm">Any Language</div>
                </div>
              </div>
            </div>

            <div className="bg-indigo-800 lg:bg-transparent px-6 py-12 lg:py-20">
              <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-md mx-auto">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-4 h-4 rounded-full animate-pulse bg-indigo-500"></div>
                  <span className="font-bold text-gray-900">{callExamples[currentCallType].type}</span>
                  <span className="text-xs text-gray-500">{callExamples[currentCallType].time}</span>
                </div>
                
                <div className="space-y-4 mb-6">
                  <div className="bg-gray-50 rounded-lg p-3">
                    <div className="text-xs text-gray-600 font-semibold mb-1">Customer:</div>
                    <div className="text-sm text-gray-800 italic">"{callExamples[currentCallType].customer}"</div>
                    {callExamples[currentCallType].translation && (
                      <div className="text-xs text-gray-500 mt-2 border-t pt-2">
                        Translation: {callExamples[currentCallType].translation}
                      </div>
                    )}
                  </div>
                  
                  <div className="rounded-lg p-3 bg-indigo-50">
                    <div className="text-xs font-semibold mb-1 text-indigo-600">AI Bilingual Response:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].response}"</div>
                  </div>
                </div>
                
                <div className="text-center">
                  <div className="text-lg font-black text-indigo-600">{callExamples[currentCallType].outcome}</div>
                  <div className="text-xs text-gray-500">Perfect communication</div>
                </div>

                <div className="flex justify-center gap-2 mt-6">
                  {callExamples.map((_, index) => (
                    <div 
                      key={index}
                      className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                        currentCallType === index ? 'bg-indigo-600' : 'bg-gray-300'
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Language Capabilities */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Native-Level <span className="text-indigo-600">Language Mastery</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              <div className="bg-indigo-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-indigo-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="translate" className="w-8 h-8 text-indigo-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Perfect Pronunciation</h3>
                <p className="text-gray-700 mb-6">
                  Native-level accent, pronunciation, and intonation in every language. Customers feel like they're speaking with a local representative.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li>• Regional accents and dialects</li>
                  <li>• Perfect pronunciation</li>
                  <li>• Natural conversation flow</li>
                  <li>• Cultural understanding</li>
                </ul>
              </div>

              <div className="bg-indigo-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-indigo-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="language" className="w-8 h-8 text-indigo-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Instant Language Detection</h3>
                <p className="text-gray-700 mb-6">
                  AI automatically detects the customer's language within seconds and seamlessly switches to provide service in their preferred language.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li>• Automatic language detection</li>
                  <li>• Seamless language switching</li>
                  <li>• No customer confusion</li>
                  <li>• Instant adaptation</li>
                </ul>
              </div>

              <div className="bg-indigo-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-indigo-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="business" className="w-8 h-8 text-indigo-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Business Terminology</h3>
                <p className="text-gray-700 mb-6">
                  Understands industry-specific terms, technical vocabulary, and business concepts in every language for professional communication.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li>• Industry-specific terms</li>
                  <li>• Technical vocabulary</li>
                  <li>• Professional tone</li>
                  <li>• Business concepts</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Popular Languages */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Popular <span className="text-indigo-600">Languages Supported</span>
            </h2>
            
            <div className="grid lg:grid-cols-4 gap-6">
              <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
                <div className="text-3xl mb-3">🇪🇸</div>
                <h3 className="font-bold text-lg text-gray-900 mb-2">Spanish</h3>
                <p className="text-gray-600 text-sm">Mexico, Spain, Latin America</p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
                <div className="text-3xl mb-3">🇫🇷</div>
                <h3 className="font-bold text-lg text-gray-900 mb-2">French</h3>
                <p className="text-gray-600 text-sm">France, Canada, Africa</p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
                <div className="text-3xl mb-3">🇨🇳</div>
                <h3 className="font-bold text-lg text-gray-900 mb-2">Mandarin</h3>
                <p className="text-gray-600 text-sm">China, Taiwan, Singapore</p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
                <div className="text-3xl mb-3">🇩🇪</div>
                <h3 className="font-bold text-lg text-gray-900 mb-2">German</h3>
                <p className="text-gray-600 text-sm">Germany, Austria, Switzerland</p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
                <div className="text-3xl mb-3">🇮🇹</div>
                <h3 className="font-bold text-lg text-gray-900 mb-2">Italian</h3>
                <p className="text-gray-600 text-sm">Italy, Vatican, San Marino</p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
                <div className="text-3xl mb-3">🇵🇹</div>
                <h3 className="font-bold text-lg text-gray-900 mb-2">Portuguese</h3>
                <p className="text-gray-600 text-sm">Brazil, Portugal, Angola</p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
                <div className="text-3xl mb-3">🇯🇵</div>
                <h3 className="font-bold text-lg text-gray-900 mb-2">Japanese</h3>
                <p className="text-gray-600 text-sm">Japan, business districts</p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
                <div className="text-3xl mb-3">🇰🇷</div>
                <h3 className="font-bold text-lg text-gray-900 mb-2">Korean</h3>
                <p className="text-gray-600 text-sm">South Korea, North Korea</p>
              </div>
            </div>
            
            <div className="text-center mt-8">
              <p className="text-gray-600 text-lg">
                <strong>Plus 40+ more languages:</strong> Arabic, Hindi, Russian, Dutch, Swedish, Polish, Turkish, Hebrew, Vietnamese, Thai, and many more.
              </p>
            </div>
          </div>
        </section>

        {/* Perfect For Diverse Businesses */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Perfect for <span className="text-indigo-600">Diverse Communities</span>
            </h2>
            
            <div className="grid lg:grid-cols-2 gap-8">
              <div className="space-y-6">
                <div className="flex items-start gap-4 bg-indigo-50 rounded-2xl p-6">
                  <MaterialIcon name="public" className="w-8 h-8 text-indigo-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">International Businesses</h3>
                    <p className="text-gray-700">Serve global customers, overseas clients, and international markets with native-level communication.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-green-50 rounded-2xl p-6">
                  <MaterialIcon name="groups" className="w-8 h-8 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Diverse Communities</h3>
                    <p className="text-gray-700">Perfect for areas with large Hispanic, French, Asian, or other non-English speaking populations.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-blue-50 rounded-2xl p-6">
                  <MaterialIcon name="business" className="w-8 h-8 text-blue-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Tourist Areas</h3>
                    <p className="text-gray-700">Hotels, restaurants, and services in tourist destinations serving international visitors.</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4 bg-purple-50 rounded-2xl p-6">
                  <MaterialIcon name="trending_up" className="w-8 h-8 text-purple-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Healthcare Providers</h3>
                    <p className="text-gray-700">Medical practices, clinics, and healthcare services needing to serve diverse patient populations.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-yellow-50 rounded-2xl p-6">
                  <MaterialIcon name="star" className="w-8 h-8 text-yellow-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Legal & Professional</h3>
                    <p className="text-gray-700">Law firms, immigration services, and professional services requiring multilingual communication.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-red-50 rounded-2xl p-6">
                  <MaterialIcon name="language" className="w-8 h-8 text-red-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Growing Businesses</h3>
                    <p className="text-gray-700">Any business looking to expand into new markets and serve broader communities.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Businesses Love <span className="text-indigo-600">Multilingual Service</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="bg-white rounded-3xl p-8 shadow-sm">
                  <div className="flex items-center gap-3 mb-6">
                    <MaterialIcon name="language" className="w-8 h-8 text-indigo-600" />
                    <div>
                      <div className="font-bold text-gray-900">{testimonial.author}</div>
                      <div className="text-sm text-gray-600">{testimonial.business}</div>
                    </div>
                  </div>
                  <p className="text-gray-700 mb-6 italic">"{testimonial.quote}"</p>
                  <div className="bg-indigo-50 rounded-xl p-4 text-center">
                    <div className="text-lg font-black text-indigo-900">{testimonial.result}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Global Reach Pricing */}
        <section className="py-16 px-6 bg-indigo-900 text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-8">
              Expand to Any Market, Any Language
            </h2>
            
            <p className="text-xl text-indigo-100 mb-8">
              One AI receptionist that speaks 50+ languages fluently. Serve every customer in their native language for the same price.
            </p>
            
            <div className="bg-white/10 rounded-3xl p-8 mb-8">
              <div className="text-6xl lg:text-7xl font-black mb-4">$399</div>
              <div className="text-xl text-indigo-100 mb-6">per month • 50+ languages • unlimited calls</div>
              
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="w-full bg-white text-indigo-900 hover:bg-indigo-50 py-4 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Get Bilingual AI →
              </button>
            </div>
            
            <p className="text-indigo-200">Ready in 24 hours • Cancel anytime • ROI guaranteed</p>
          </div>
        </section>

        {/* Waitlist Modal */}
        <Modal
          isOpen={showWaitlistModal}
          onClose={() => setShowWaitlistModal(false)}
          title="Get Your Bilingual AI"
        >
          {waitlistSuccess ? (
            <div className="text-center">
              <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">¡Perfecto! Perfect! 完美!</h3>
              <p className="text-gray-600">We'll have your multilingual AI ready within 24 hours of launch.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  required
                  value={waitlistData.name}
                  onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  placeholder="e.g. Maria Rodriguez"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
                <input
                  type="email"
                  required
                  value={waitlistData.email}
                  onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  placeholder="maria@business.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Phone</label>
                <input
                  type="tel"
                  required
                  value={waitlistData.phone}
                  onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  placeholder="(555) 123-4567"
                />
              </div>
              
              <button
                onClick={handleWaitlistSubmit}
                disabled={waitlistLoading}
                className="w-full bg-indigo-900 hover:bg-indigo-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {waitlistLoading ? 'Setting Up Your AI...' : 'Get My Bilingual AI'}
              </button>
            </div>
          )}
        </Modal>

        {/* Related Services */}
        <RelatedServices currentService="/bilingual-ai-receptionist" />

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default BilingualAIReceptionist;